import { OurWorkPage } from '@/components/type/type';
import { project } from './allProject';

const ALL_INDUSTRIES = [
  'Healthcare & Fitness',
  'Education & E-Learning',
  'Retail & Ecommerce',
  'Finance, Fintech & BFSI',
  'Construction & Real Estate',
  'Transport & Logistics',
  'Food & Restaurant',
  'Travel & Hospitality',
  // 'Sports, Gaming & Entertainment',
  'Energy & Utilities',
  'Social Networking & Media',
  'SaaS & Information Technology',
];

const ALL_SERVICES = [
  'Artificial Intelligence & ML',
  'Generative AI Solutions',
  'Data Engineering & Analytics',
  'Custom Development Services',
  'Cloud & DevOps',
];
export const ourWorkPage: OurWorkPage = {
  headingTitle: 'Our Works',
  headingDescription: `Explore our portfolio of innovative projects that showcase our expertise in delivering high-quality digital solutions. From modern web applications to scalable backend systems, each project reflects our commitment to performance, creativity, and user-focused design.`,
  heroRightImage: '/webp/our-work/our-work.webp',
  tabs: ['All', 'Industries', 'Services'],
  industriesList: ALL_INDUSTRIES,
  servicesList: ALL_SERVICES,
  projects: project,
};
